<template>
    <a-modal v-model="visible" title="财务核对费用" @ok="handleOk" destroyOnClose @cancel="handleClose"
        :confirmLoading="confirmLoading" :maskClosable="false">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="核对结果" prop="process_status">
                <a-radio-group v-model="form.process_status">
                    <a-radio value="1">
                        待核对
                    </a-radio>
                    <a-radio value="2">
                        核对通过
                    </a-radio>
                    <a-radio value="3">
                        核对不通过
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="拒绝原因" prop="process_reason" v-if="form.process_status == 3">
                <a-input v-model="form.process_reason" placeholder="核对拒绝原因"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
// import moment from 'moment'
import { baseURL } from "@/api/index";
export default {
    data() {
        return {
            baseURL,
            visible: false,
            confirmLoading: false,
            form: {
                external_id: [], //交易id
                process_status: "", //
                process_reason: "", //
            },
            fileList: [],
            submitLoading: false,
            rules: {
                process_status: {
                    required: true,
                    message: "核对结果必填",
                    trigger: "change",
                },
                process_reason: {
                    required: true,
                    message: "核对拒绝原因必填",
                    trigger: "change",
                },
            },
            labelCol: { span: 7 },
            wrapperCol: { span: 15 },
        };
    },
    methods: {
        init(external_id) {
            this.form.external_id = external_id;
            this.visible = true;
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: "/admin/tripexternal/batchReceivePaymentExamineResult",
                        method: "post",
                        data: {
                            ...this.form,
                            external_ids: this.form.external_id,
                        },
                    })
                        .then(() => {
                            this.$message.success('核对操作成功');
                            this.handleClose();
                            this.$emit("ok");
                        })
                        .finally(() => (this.confirmLoading = false));
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.$refs.ruleForm.resetFields();
            this.visible = false;
        },
    },
};
</script>

<style></style>